import {createContext} from 'react';

export const RetailerProfilesEditContext = createContext({
    picturesToDeleted: [],
    setPicturesToDelete: () => {},
    isClickAndCollect: false,
    setClickAndCollect: () => {},
    isAllowedToChangeLogo: false,
})
